import React from 'react';
import { useAppSelector } from '../../redux/store';
import { selectDocumentSearchQueryId } from '../../redux/selectors/documentSearchSelectors';
import SimpleLegalQueryProgress from '../legal-query-progress/simple-legal-query-progress';

const DocumentSearchProgress: React.FC = () => {
  const queryId = useAppSelector(selectDocumentSearchQueryId);
  const currentChatId = useAppSelector(state => state.ChatReducer.currentChatId);

  if (!queryId || !currentChatId) {
    return null;
  }

  return (
    <div className="max-w-[900px] mx-auto">
      <SimpleLegalQueryProgress
        chatId={currentChatId}
        compact={false}
      />
    </div>
  );
};

export default DocumentSearchProgress;

